import React from 'react'
import { NavLink } from 'react-router-dom'
const Error = () => {
    return (
        <>
            <section className="error">
                <div className="container">
                    <div className="content">
                        <h1>Opps!</h1>
                        <img src="img/404.png" alt='404 Image' className='img-fluid' />
                        <p>"We're sorry, but it looks like there's been a bit of a hiccup in your journey through our website. The page you were looking for may have taken a wrong turn or decided to hide. Worry. Don't, our websites are on it, trying to fix the problem. In the meantime, you can return to our other great pages or contact our support team for help. Phone number and Gmail are also provided on the site. Thank you for your patience and understanding as we work to make your browsing experience even smoother."</p>
                        <NavLink to="/" className='btn-button'>GO HOME PAGE</NavLink>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Error